export const cities = [
  "Whitefield",
  "Hennur",
  "Mysore",
  "Banashankari",
  "Carmelaram",
  "Electronic City",
  "Yelahanka",
  "Harlur Road",
  "Coimbatore"
];